import { Inline, useCollapse } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useSkusImport } from 'hooks'
import { LIMITS } from 'shared'
import { Item } from 'typings'
import { SkuSelector } from 'ui'
import { CollapsibleRule } from '../CollapsibleRule'
import { SelectorComponentProps } from '../constants'
import { OperatorSelector } from '../OperatorSelector'

export function SkusScopeSelector(props: SelectorComponentProps) {
  const { name, form, open } = props

  const items: Item[] = useWatch({ form, name: `${name}.items` })

  const collapsibleState = useCollapse({ visible: open })

  const { importSkus, loading } = useSkusImport()

  return (
    <CollapsibleRule state={collapsibleState}>
      <CollapsibleRule.Header
        state={collapsibleState}
        onRemove={() => form.setValue(name, undefined)}
      >
        <CollapsibleRule.Title state={collapsibleState} count={items.length}>
          <SkuSelector.Header />
        </CollapsibleRule.Title>
      </CollapsibleRule.Header>
      <CollapsibleRule.Content
        state={collapsibleState}
        focusId={`${name}.items`}
      >
        <SkuSelector>
          <CollapsibleRule.Actions>
            <OperatorSelector name={`${name}.operator`} form={form} />
            <Inline>
              <SkuSelector.Download values={items} />
              <SkuSelector.Upload
                name={`${name}.items`}
                form={form}
                importer={importSkus}
                maxEntries={LIMITS.MAX_SKUS}
              />
            </Inline>
          </CollapsibleRule.Actions>
          <SkuSelector.Selector
            name={`${name}.items`}
            state={form}
            loading={loading}
          />
        </SkuSelector>
      </CollapsibleRule.Content>
    </CollapsibleRule>
  )
}
